import { useToast } from './Toast';
import { useI18n } from '@/i18n';

/** One-click copy used next to IDs/emails/phones/URLs across every module. */
export function CopyButton({ value }: { value: string }) {
  const push = useToast();
  const { t } = useI18n();
  return (
    <button
      className="copy-btn"
      title={t('common.copy')}
      onClick={(e) => {
        e.stopPropagation();
        navigator.clipboard?.writeText(value).then(() => push(t('common.copied'), 'info'));
      }}
    >
      ⧉
    </button>
  );
}
